import { mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { GetManyResponse, IRequestPayload } from 'core/types';
import { getQueryStringToSnakeCase, objectKeysCamelToSnakeCase } from 'core/utils';
import { ICorporateUserAutocomplete, ICorporateUserUpsertForm } from 'corporate/types';

export const getCorporateUsersAutocomplete = async (
  requestPayload: IRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<ICorporateUserAutocomplete>> => {
  const { data } = await partfinitiClient.get(
    `/corporate/user/autocomplete?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<ICorporateUserAutocomplete>(data.corporate_users, data.total_count);
};

export const getCorporateForeignUsersAutocomplete = async (
  requestPayload: IRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<ICorporateUserAutocomplete>> => {
  const { data } = await partfinitiClient.get(
    `/corporate/foreign-user/autocomplete?${getQueryStringToSnakeCase(requestPayload, {
      removeNullValues: true,
    })}`,
    signal
  );

  let corporateUsers = data?.corporate_users;

  if (
    requestPayload?.viewBy?.contactGroupId &&
    requestPayload?.viewBy?.includeOtherContactGroups !== 0
  ) {
    const targetGroupId = requestPayload.viewBy.contactGroupId;

    corporateUsers = corporateUsers.map((corporateUser) => {
      const contactGroup = corporateUser.contact_group;

      return {
        ...corporateUser,
        mainContactGroup: Number(contactGroup.id) === Number(targetGroupId),
        otherContactGroup: Number(contactGroup.id) !== Number(targetGroupId),
      };
    });
  }

  return mapRecordsFromServer<ICorporateUserAutocomplete>(corporateUsers, data.total_count);
};

export const upsertCorporateUser = async (data: ICorporateUserUpsertForm) =>
  partfinitiClient.postForm('/corporate/user/save', objectKeysCamelToSnakeCase(data));

export const changeUserVersion = async (data: { alternateVersionEnabled: number }) =>
  partfinitiClient.postForm('/corporate/user/change-user-version', data);
